import { Injectable } from '@angular/core';
import { CONFIG } from '../../config';


@Injectable()
export class LocalStorageService {
  private readonly storagePrefix: string;

  constructor(
  ) {
    this.storagePrefix = CONFIG.storagePrefix;
  }

  public set(name: string, elem: any) {
    localStorage.setItem(`${this.storagePrefix}-${name}`, JSON.stringify(elem));
  }

  public get(name: string) {
    return JSON.parse(localStorage.getItem(`${this.storagePrefix}-${name}`));
  }

  public delete(name: string) {
    localStorage.removeItem(`${this.storagePrefix}-${name}`);
  }

  public deleteAll() {
    localStorage.clear();
  }
  // This web browser tab reserves the right to refresh the access token.  It does this by setting a lock
  // flag in local storage (this function returns "true").  Any other browser tab that wants to refresh the
  // access token will invoke this function and get "false" back until the lock is removed.
  // Please note that this method is not threadsafe across multiple browser tabs.
  public reserveToRefreshToken() {
    const name = `${this.storagePrefix}-refreshingAccessToken`;
    if (localStorage.getItem(name) != null) {
      // Someone else is already refreshing the access token
      return false;
    }
    // I can refresh the access token.  Update lock flag in local storage
    localStorage.setItem(name, 'true');
    return true;
  }

  // Checks if the lock flag is set for refreshing the access token.
  public isRefreshingToken() {
    return localStorage.getItem(`${this.storagePrefix}-refreshingAccessToken`) != null;
  }

  // Releases the lock on refreshing the access token.  Other tabs will be able to see that the
  // access token refresh is done and/or be able to reserve it themselves.
  public refreshTokenFinished() {
    localStorage.removeItem(`${this.storagePrefix}-refreshingAccessToken`);
  }

}

